<style lang="less">
.tip-wrapper {
  position: absolute;
  right: 0px;
  padding: 20px 8px;
  background: #FFFF80;
  cursor: pointer;
  & a {
    color: #333 !important;
  }
}
</style>

<template>
  <div class="tip-wrapper" >
    <router-link to="/gonggao.html" target="_blank" >
      学习民法典，护航新生活
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'ResidentAnnouncement',
  props: {},
  data () {
    return {
      rownum: 8,
      screenWidth: document.body.clientWidth
    }
  },

  methods: {
    handlePlay (mid) {
      window.open('/player/?mid=' + mid + '&cid=' + this.channel_id)
      // this.$router.push('/play/')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ResidentAnnouncement.vue